import { MoreIcon } from '@/icons'

import s from './More.module.css'

export const More = () => {
  return <div className={s.icon}>{MoreIcon}</div>
}
